import {constants} from "./Constants";
import moment from "moment";

//Given a time variable in the format of 10:00 PM, return the time in the array
export function receiveTime(time) {
    var time_in_array = 1;
    var cloned_time = moment(time, "h:mmA").clone().format("h:mm")
    for (var i = 0; i < constants.time_array.length; i++) {
        if (cloned_time === constants.time_array[i]) {
            time_in_array = i + 1

            if (moment(time, "h:mmA").get('hour') > 11.5) {
                time_in_array = time_in_array + 24
            }
        }
    }

    return time_in_array
}

//given a value of time from the array, return the actual timing
export function reverseReceiveTime(time) {
    var timing = time - 1
    var suffix = " am"
    if (timing === 24) {
        return '12:00 pm'
    } else if (timing > 24) {
        timing = timing - 24;
        suffix = " pm"
    } 
    else if(isNaN(timing)) {        
        return time
    }

    return constants.time_array[timing] + suffix
}

//Given a vmh or sh/vmh start time and end time, generate 30 minute intervals until 
export function generateTimings(start, end) {
    var starting_moment = moment().set('hour', start).set('minute', 0);
    var timings = [];

    while (starting_moment.get('hour') <= end) {
        timings.push(
            starting_moment.clone().format("h:mmA")
        )

        starting_moment.add(30, 'minutes')
    }

    return timings;
}

/**
 * Takes an input object to check if there are any invalid dates.
 * If a date is not a valid date, it is replaced with a date from the current state.
 *
 * @param {Object} input A key/value pair with some date values to be validated.
 * @param {Object} currentState A key/value pair of dates to replace invalid dates with.
 * @returns {Object} A key/value pair with only valid dates.
 */
export const validateInputDates = (input, currentState) => {
    const validatedInput = { ...input };
    Object.keys(input).forEach((key) => {
        if (input[key] === 'Invalid date') {
            validatedInput[key] = currentState[key];
        }
    });
    return validatedInput;
};
